var swiper = new Swiper(".swiper-product", {
    slidesPerView: 1,
    effect: "fade",
    spaceBetween: 30,
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
});
